/** Caminho do arquivo aberto (a paleta, a barra de status e as checagens leem fora do React). */
let activePath = "";

export function setActivePluginPath(path: string) {
  activePath = path;
}

export function activePluginPath(): string {
  return activePath;
}
